import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=20c23a8c"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c23a8c')) {
      api.createRecord('20c23a8c', component.options)
    } else {
      api.reload('20c23a8c', component.options)
    }
    module.hot.accept("./Items.vue?vue&type=template&id=20c23a8c", function () {
      api.rerender('20c23a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/schedule/Items.vue"
export default component.exports